import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from './toggle';
import styles from './compare_toggle.css';

const IconToggleRebrand = ({ icon, handleClick, isSelected, showLabel }) => (
    <div className={styles.root}>
        <Toggle className={styles.bullet} handleClick={handleClick}>
            {icon}
            {showLabel && <span className={styles.label}>{isSelected ? 'Selected' : 'Compare'}</span>}
        </Toggle>
    </div>
);

IconToggleRebrand.propTypes = {
    showLabel: PropTypes.bool.isRequired,
    icon: PropTypes.element.isRequired,
    handleClick: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired
};

export { IconToggleRebrand };

